export const HEADING = 'Sleep apnea details';
